export default __webpack_public_path__ + "static/media/img-youtube.da4e29ba.png";